module.exports = __webpack_public_path__ + "img/自动上下料机.e5d48106.jpg";